import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { api } from '../../api/api';

export const loadDashboard = createAsyncThunk(
  'dashboard/loadDashboard',
  async ({ projectId, filters = {} }) => {
    const response = await api.dashboard(projectId, filters);
    return response;
  },
);

export const loadBackendVersion = createAsyncThunk(
  'dashboard/loadBackendVersion',
  async () => {
    const response = await api.version();
    return response;
  },
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    data: null,
    loading: false,
    error: null,
    filters: {
      period_days: 7,
      from_date: null,
      to_date: null,
    },
    backendVersion: null,
    backendVersionLoading: false,
  },
  reducers: {
    resetDashboard(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: {
    [loadDashboard.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [loadDashboard.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [loadDashboard.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },
    [loadBackendVersion.pending]: (state) => {
      state.backendVersionLoading = true;
    },
    [loadBackendVersion.fulfilled]: (state, action) => {
      state.backendVersionLoading = false;
      state.backendVersion = action.payload;
    },
    [loadBackendVersion.rejected]: (state) => {
      state.backendVersionLoading = false;
      state.backendVersion = null;
    },
  },
});

export const { resetDashboard, setFilters } = dashboardSlice.actions;

export const selectDashboard = (state) => state.dashboard.data;
export const selectDashboardLoading = (state) => state.dashboard.loading;
export const selectDashboardError = (state) => state.dashboard.error;
export const selectDashboardFilters = (state) => state.dashboard.filters;
export const selectBackendVersion = (state) => state.dashboard.backendVersion;
export const selectBackendVersionLoading = (state) =>
  state.dashboard.backendVersionLoading;

export default dashboardSlice.reducer;
